module.exports = __webpack_public_path__ + "static/18-Affinity-Mapping-1d22a645c20a48754be4eb7c1e4a84fd.jpg";